import { render, staticRenderFns } from "./ReferralContextMenu.vue?vue&type=template&id=715bae0b"
import script from "./ReferralContextMenu.vue?vue&type=script&lang=js"
export * from "./ReferralContextMenu.vue?vue&type=script&lang=js"
import style0 from "./ReferralContextMenu.vue?vue&type=style&index=0&id=715bae0b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports